import {Link} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc/*, postApi*/} from '../utils/functions';
import {UserContext} from '../utils/usercontext';
import EventEmitter from '../utils/emmiter';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import './components/fontawesome/fontawesome';

export default class HomePage extends React.Component {
	static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			top: true,
			//toggle: false,
      page: '',
			Page: null,
		};
  };

  async componentDidMount() {
    const value = this.context;
    const getUser = await useracc();
    value.setUser( getUser );
    value.setTheme( '/themes/default-dark.css' );
    EventEmitter.emit('/client', {data: 'no value'});

		const Page = EventEmitter.addListener('/page', async data => {
			this.setState({page: data.data});
		}); this.setState({Page});

		window.onscroll = ()=>{
			let top = this.state.top;
			if( window.pageYOffset === 0 && !top ) this.setState({top: true});
			if( window.pageYOffset !== 0 && top ) this.setState({top: false});
      /*if(window.pageYOffset === 0) {
        alert('I AM AT THE TOP');
      }*/
    };
		document.body.addEventListener('click', this.toggleSidemenu);
    this.toggleSidemenu = this.toggleSidemenu.bind(this);
		this.openSidemenu = this.openSidemenu.bind(this);
  }

	componentWillUnmount() {
		window.onscroll = null;
		document.body.removeEventListener('click', this.toggleSidemenu);
	}

	toggleSidemenu(event) {
		let element = document.getElementById('landing-page-wrapper');
		if( element && element.contains(event.target) ) { // or use: event.target.closest(selector) === null
			let html = document.documentElement;
			if( html ) html.setAttribute("data-toggled", 'close');
		}


	}

	openSidemenu(status) {
		let element = document.documentElement;
		element.setAttribute("data-toggled", status);
	}


	render() {
		return (
			<div className="landing-page-wrapper">
        <header className="app-header">
          <div className="main-header-container container-fluid">
            <div className="header-content-left">
              <div className="header-element">
                <div className="horizontal-lfaListriogo">
									<Link to="/" className="header-logo">
										<img src="../assets/images/brand-logos/toggle-logo.png" alt="logo" className="toggle-logo" />
										<img src="../assets/images/brand-logos/toggle-dark.png" alt="logo" className="toggle-dark" />
									</Link>
								</div>
              </div>
              <div className="header-element" onClick={()=>{this.openSidemenu('open')}}>
                <span aria-label="anchor" className="sidemenu-toggle header-link" data-bs-toggle="sidebar"> <span className="open-toggle" style={{cursor: 'pointer'}}> <FontAwesomeIcon icon="bars" /> </span> </span>
              </div>
            </div>
            
            <div className="header-content-right">
              <div className="header-element align-items-center">
                <div className="btn-list d-lg-none d-block">
									{/*<button type="button" className="btn btn-primary-light d-sm-inline d-none"> Sign Up </button>*/}
									<a href="https://portal.ultrastream.io" className="btn btn-wave btn-success"> Client Area </a>
									{/*<button aria-label="anchor" type="button" className="btn btn-icon btn-success" data-bs-toggle="offcanvas" data-bs-target="#switcher-canvas"> <i className="ri-settings-3-line"></i> </button>*/}
								</div>
              </div>
            </div>
          </div>
        </header>
    
        <aside className={`app-sidebar ${this.state.top===false&&'sticky'}`} id="sidebar">
          <div className="container p-0">
            <div className="main-sidebar">
              <nav className="main-menu-container nav nav-pills sub-open">
                <div className="landing-logo-container">
                  <div className="horizontal-logo">
										<Link to="/" className="header-logo" onClick={()=>this.openSidemenu('close')}>
											<img src={`https://cloud.ultrastream.io/images/logo-us-large.png?d=${Math.floor(Date.now()/1000)}`} alt="logo" className="desktop-logo" /> <img src="../assets/images/brand-logos/desktop-dark.png" alt="logo" className="desktop-dark" />
										</Link>
									</div>
                </div>
								<div className="slide-left d-none" id="slide-left">
									<svg xmlns="http://www.w3.org/2000/svg" fill="#7b8191" width="24" height="24" viewBox="0 0 24 24"> <path d="M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z"></path> </svg>
								</div>
								<ul className="main-menu" style={{marginLeft: 0, marginRight: 0}}>

									{/*<li className="slide has-sub open">
										<a href="javascript:void(0);" className="side-menu__item">
											<span className="side-menu__label">More</span>
											<i className="fe fe-chevron-right side-menu__angle"></i>
										</a>
										<ul className="slide-menu child1 active" style={{position: 'relative', left: 0, top: 0, margin: 0, boxSizing: 'border-box', transform: 'translate(601px, 50px)', display: 'none'}} data-popper-placement="bottom">
											<li className="slide">
												<a href="#statistics" className="side-menu__item">Statistics</a>
											</li>
											<li className="slide">
												<a href="#clients" className="side-menu__item">Clients </a>
											</li>
											<li className="slide">
												<a href="#our-mission" className="side-menu__item">Our Mission</a>
											</li>
											<li className="slide has-sub">
												<a href="javascript:void(0);" className="side-menu__item">Level-2
													<i className="fe fe-chevron-right side-menu__angle"></i>
												</a>
												<ul className="slide-menu child2 active" style={{boxSizing: 'border-box', display: 'none'}}>
													<li className="slide">
														<a href="javascript:void(0);" className="side-menu__item">Level-2-1</a>
													</li>
													<li className="slide has-sub">
														<a href="javascript:void(0);" className="side-menu__item">Level-2-2
															<i className="fe fe-chevron-right side-menu__angle"></i>
														</a>
														<ul className="slide-menu child3 active" style={{boxSizing: 'border-box', display: 'none'}}>
															<li className="slide">
																<a href="javascript:void(0);" className="side-menu__item">Level-2-2-1</a>
															</li>
															<li className="slide has-sub">
																<a href="javascript:void(0);" className="side-menu__item">Level-2-2-2</a>
															</li>
														</ul>
													</li>
												</ul>
											</li>
										</ul>
									</li>*/}

									<li className="slide">
										<Link to="/restream" onClick={()=>this.openSidemenu('close')} className={`side-menu__item ${this.state.page==='restream'&&'active'}`} > <span className="side-menu__label">Restream</span></Link>
									</li>
									<li className="slide">
										<Link to="/emojicrew" onClick={()=>this.openSidemenu('close')} className={`side-menu__item ${this.state.page==='emojicrew'&&'active'}`}> <span className="side-menu__label">EmojiCrew</span></Link>
									</li>
									<li className="slide">
										<Link to="radio" onClick={()=>this.openSidemenu('close')} className={`side-menu__item ${this.state.page==='radio'&&'active'}`}> <span className="side-menu__label">Radio Station</span> </Link>
									</li>
									<li className="slide">
										<Link to="radiosuite" onClick={()=>this.openSidemenu('close')} className={`side-menu__item ${this.state.page==='radiosuite'&&'active'}`}> <span className="side-menu__label">Radio Station Suite</span> </Link>
									</li>
									
									{/*<li className="slide"> <a href="#pricing" className="side-menu__item"> <span className="side-menu__label">Pricing</span> </a> </li>
									<li className="slide"> <a href="#faq" className="side-menu__item"> <span className="side-menu__label">Faq's</span> </a> </li>
									<li className="slide"> <a href="#testimonials" className="side-menu__item"> <span className="side-menu__label">Testimonials</span> </a> </li>
									<li className="slide"> <a href="#contact" className="side-menu__item"> <span className="side-menu__label">Contact</span> </a> </li>*/}
								</ul>
								{/*<div className="slide-right d-none" id="slide-right">
									<svg xmlns="http://www.w3.org/2000/svg" fill="#7b8191" width="24" height="24" viewBox="0 0 24 24"> <path d="M10.707 17.707 16.414 12l-5.707-5.707-1.414 1.414L13.586 12l-4.293 4.293z"></path> </svg>
								</div>*/}
								<div className="d-lg-flex d-none">
									<div className="btn-list d-xl-flex d-none">
										<a href="https://portal.ultrastream.io" className="btn btn-wave btn-success">Client Area</a>
										{/*<button type="button" aria-label="button" className="btn btn-wave btn-icon btn-light" data-bs-toggle="offcanvas" data-bs-target="#switcher-canvas">
											<i className="ri-settings-3-line"></i>
										</button>*/}
									</div>
								</div>
							</nav>
            </div>
      	  </div>
  		  </aside>
 	   </div>
		)
	}
}